module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-overlay",
    on: {
      "click": function($event) {
        _vm.hideOverlay()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a08aa64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/overlay.vue
// module id = 2519
// module chunks = 80